import React from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { COLORS } from '../../../../config/designSystem/Colors';
import { PresentInstruction } from './PresentInstruction';

/**
 * An instruction question is a page to read, so it is drawn by the same
 * static-frame presentation as a FRAME step rather than by one of its own.
 */
const meta = {
  title: 'Session/Frames/Instruction',
  component: PresentInstruction,
  args: {
    questionId: 'story-instruction',
    questionType: 'instruction',
    questionText: 'Take a moment to settle',
    questionDescription:
      'Find a quiet spot, sit comfortably and let your shoulders drop. There is nothing to answer here — read it through and continue when you are ready.',
    margin: 16,
  },
  decorators: [
    // full width: StaticFrame sets its own responsive side margins from the
    // window, so a narrow box would squeeze the frame into a thin column
    Story => (
      <View
        style={{
          alignSelf: 'stretch',
          minHeight: 560,
          justifyContent: 'center',
          backgroundColor: COLORS.surface.primary,
        }}
      >
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof PresentInstruction>;

export default meta;

type Story = StoryObj<typeof meta>;

export const TitleAndText: Story = {};

export const WithPicture: Story = {
  args: {
    questionImage: 'https://picsum.photos/seed/evoluno-instruction/240/240',
  },
};

/** the question carries no description: the title stands on its own */
export const TitleOnly: Story = {
  args: {
    questionDescription: '',
  },
};

export const Loading: Story = {
  args: {
    loading: true,
  },
};
